module.exports = __webpack_public_path__ + "static/media/reward.502ede94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pet_icons/reward.svg
// module id = 177
// module chunks = 0